import { orderBy } from 'lodash';
export default {
    /**
     * 递归地将带children的数组展平
     */
    deepFlatten(list, key = 'children') {
        const result = [];
        const flatten = (arry) => arry.forEach((item) => {
            const newItem = Object.assign({}, item);
            delete newItem[key];
            result.push(newItem);
            if (item[key] && Array.isArray(item[key])) {
                flatten(item[key]);
            }
        }, []);
        flatten(list);
        return result;
    },
    /**
     * 根据某个字段 递归排序
     */
    deepOrder(props) {
        const { data = [], childKey, orderKey, type = 'asc' } = props;
        const loopOrder = (params) => {
            const { data = [], childKey, orderKey, type = 'asc' } = params;
            return orderBy(data, orderKey, type).map((item) => {
                const children = item[childKey] || [];
                if (children && children.length > 0) {
                    item[childKey] = loopOrder({ data: children, childKey, orderKey, type });
                }
                return item;
            });
        };
        return loopOrder({ data, childKey, orderKey, type });
    },
};
